export default "__VITE_ASSET__C$vI9GU$__"